module.exports = __webpack_public_path__ + "static/media/sticker-icon.af9f7f56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/sticker-icon.svg
// module id = 508
// module chunks = 21